import styled from 'styled-components/macro';
import StyledFlexContainer from './StyledFlexContainer';

const WorkContent = styled(StyledFlexContainer)`
	align-items: center;
	padding: 0.5rem;
	width: 100%;
	position: relative;
	flex-direction: column;

	h4 {
		margin-top: 1rem;
		line-height: 1.5;
		text-transform: uppercase;
		@media screen and (min-width: 2000px) {
			margin-top: 3rem;
		}
	}
`;

export default WorkContent;
